import React, { useState } from "react";
import { Box, Input, Modal, Button } from "@sainsburys-tech/fable";
import Headerfile from "../../common/Headerfile";
import Footerfile from "../../common/Footerfile";
import Styles from "./AddTemplate.module.css";
import { useNewPostMutation } from "../../../api/apiConfig";
import { getLogisticsRole } from "../../../utils/authToken";
import { USER_ROLE } from "../../../constants/roles";
import Unauthorized from "../../unauthorized/Unauthorized";
import { useRef } from "react";
const AddTemplate = () => {
  const inputFile: any = useRef(null);
  const inputImage: any = useRef(null);

  const [isSubmitted, setIsSubmitted] = useState(false);

  const [apiHeading, setApiHeading] = useState<string | null>(null);
  const [apiMessage, setApiMessage] = useState<string | null>(null);
  const [isResponseOpen, setResponseOpen] = useState(false);
  const [newPost] = useNewPostMutation();

  const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(false);

  interface IData {
    StatusCode: number;
    Status: string;
    TotalRecords?: number;
    Message?: string;
    Model?: any;
    Value?: string;
  }
  interface IResponse {
    data: IData;
    TotalRecords: number;
  }

  const [values, setValues] = useState<IState>({
    Id: "",
    Identity: {
      SBTemplateId: "",
      Name: "",
      Description: ""
    },
    Configuration: {
      TemplateFormat: null,
      Height: "",
      Width: "",
      Image: null
    }
  });
  interface IState {
    Id: string;
    Identity: {
      SBTemplateId: string;
      Name: string;
      Description: string;
    };
    Configuration: {
      TemplateFormat: string | any;
      Height: string;
      Width: string;
      Image: File | any | Blob;
    };
  }
  interface IErrors {
    Id?: string;
    Identity?: {
      SBTemplateId?: string;
      Name?: string;
      Description?: string;
    };
    Configuration?: {
      TemplateFormat?: string | any;
      Height?: string;
      Width?: string;
      Image?: File | any;
    };
  }

  const [Zplfileformat, setZplfileformat] = useState<string>("");
  const [errors, setErrors] = useState<IErrors>({});

  function toBinaryStr(str: string) {
    const encoder = new TextEncoder();
    const charCodes = encoder.encode(str);
    return String.fromCharCode(...charCodes);
  }
  const handleChange = (
    name: string,
    value: string | boolean | File | Blob
  ) => {
    const keys = name.split(".");
    if (keys.length === 1) {
      setValues({ ...values, [name]: value });
    } else {
      setValues((prevValues) => {
        let updatedValues: any = { ...prevValues };
        let current: any = updatedValues;
        for (let i = 0; i < keys.length - 1; i++) {
          current = current[keys[i]];
        }
        current[keys[keys.length - 1]] = value;
        return updatedValues;
      });
    }
  };

  const onChangeFile = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const files: FileList | null = e.target.files;
    const file: File | null = files ? files[0] : null;
    if (file) {
      getBase64(file);
    }
  };
  const onLoad = (fileString: string | ArrayBuffer | null): void => {
    let separatedArray: string[] = (fileString as string).split(",");
    handleChange("Configuration.Image", separatedArray[1]);
  };

  const getBase64 = (file: File): void => {
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (): void => {
      onLoad(reader.result);
    };
  };
  function isIResponse(response: any): response is IResponse {
    return response.data !== undefined && typeof response.data === "object";
  }
  const initialState: IState = {
    Id: "",
    Identity: {
      SBTemplateId: "",
      Name: "",
      Description: ""
    },
    Configuration: {
      TemplateFormat: null,
      Height: "",
      Width: "",
      Image: File
    }
  };
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitted(true);
    const validationErrors = validate(values);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      setIsSaveButtonDisabled(true);
      try {
        const response = await newPost({
          Method: "templates",
          ...values
        });
        if (
          isIResponse(response) &&
          response.data.StatusCode === 0 &&
          response.data.Status === "Ok"
        ) {
          setIsSaveButtonDisabled(false);
          setApiMessage("Template created successfully" || null);
          setApiHeading("Success!!!");
          setResponseOpen(true);
          setValues(initialState);
          inputFile.current.value = "";
          inputFile.current.type = "text";
          inputFile.current.type = "file";
          inputImage.current.value = "";
          inputImage.current.type = "text";
          inputImage.current.type = "file";
        } else if (isIResponse(response) && response.data) {
          setIsSaveButtonDisabled(false);
          setApiMessage(response.data.Message || null);
          setApiHeading("Error!!!");
          setResponseOpen(true);
          console.error("Error response:", response);
        } else {
          setIsSaveButtonDisabled(false);
          console.error("Something Went Wrong..", response);
        }
      } catch (error) {
        setIsSaveButtonDisabled(false);
        console.error(error);
      }
    }
  };

  const validate = (values: IState) => {
    let errors: any = {};
    if (!values.Identity.SBTemplateId) {
      errors.Identity = {
        ...errors.Identity,
        SBTemplateId: "Sainsburys Template id is Required"
      };
    }
    if (!values.Identity.Name) {
      errors.Identity = {
        ...errors.Identity,
        Name: "Template Name is required"
      };
    }
    if (!values.Identity.Description) {
      errors.Identity = {
        ...errors.Identity,
        Description: "Description is required"
      };
    }
    if (!values.Configuration.TemplateFormat) {
      errors.Configuration = {
        ...errors.Configuration,
        TemplateFormat: "ZPL file is required"
      };
    }
    if (values.Configuration.TemplateFormat) {
      var myblob = new Blob([values.Configuration.TemplateFormat], {
        type: "text/plain"
      });
      const fileSize = myblob.size / 1024 / 1024;
      if (Zplfileformat === "txt" || Zplfileformat === "prn") {
      } else if (fileSize > 2) {
        errors.Configuration = {
          ...errors.Configuration,
          Image: "File size should be less than 2MB"
        };
      } else {
        errors.Configuration = {
          ...errors.Configuration,
          TemplateFormat: "Only text and prn files are allowed"
        };
      }
    }

    if (!values.Configuration.Image) {
      errors.Configuration = {
        ...errors.Configuration,
        Image: "Image is required"
      };
    }
    if (values.Configuration.Image) {
      let fileType = "";
      if (values.Configuration.Image.startsWith("/9j")) {
        fileType = "image/jpeg";
      } else if (values.Configuration.Image.startsWith("iV")) {
        fileType = "image/png";
      } else {
        fileType = "";
      }
      const fileSize = values.Configuration.Image.size / 1024 / 1024;
      const validImageTypes = ["image/jpeg", "image/png"];

      if (!validImageTypes.includes(fileType)) {
        errors.Configuration = {
          ...errors.Configuration,
          Image: "Only JPG and PNG files are allowed"
        };
      }

      if (fileSize > 2) {
        errors.Configuration = {
          ...errors.Configuration,
          Image: "File size should be less than 2MB"
        };
      }
    }
    return errors;
  };

  let fileReader: FileReader;
  const onChangetext = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const file: FileList | null = e.target.files;
    if (file) {
      var fileextation = file[0].name.split(".");
      fileReader = new FileReader();
      fileReader.onloadend = handleFileRead;
      setZplfileformat(fileextation[1]);
      fileReader.readAsText(file[0]);
    }
  };

  const cleanContent = (string: string): string => {
    string = string.replace(/^\s*[\r\n]/gm, "");
    let array: string[] = string.split(new RegExp(/[\r\n]/gm));
    return array.join("\n");
  };

  const handleFileRead = (e: ProgressEvent<FileReader>): void => {
    let content: string | null = fileReader.result as string;
    content = cleanContent(content);
    handleChange("Configuration.TemplateFormat", btoa(toBinaryStr(content)));
  };
  const loggedUserRole = getLogisticsRole();

  const isDisabled =
    loggedUserRole?.includes(USER_ROLE.ADMIN) ||
    loggedUserRole?.includes(USER_ROLE.READ_WRITE)
      ? false
      : true;

  return (
    <div data-testid={"AddtemplateDiv"}>
      <div className={Styles.container} data-testid={"container"}>
        <Headerfile />
        {isDisabled ? (
          <Unauthorized />
        ) : (
          <Box as="div" className={Styles.box}>
            <form
              data-testid={"form"}
              onSubmit={handleSubmit}
              className={Styles.formContainer}
            >
              <h5 className={Styles.heading}>Add Template</h5>
              <p className={Styles.rightAlign}>
                <span className={Styles.redAsterisk}>*</span>Indicates required
                field
              </p>{" "}
              <label className={Styles.label}>
                <Input
                  name="Identity.TemplateId"
                  label="Sainsburys Template Id*"
                  autocomplete="off"
                  type="text"
                  value={values.Identity.SBTemplateId}
                  onChange={(e) => handleChange("Identity.SBTemplateId", e)}
                />
              </label>
              {isSubmitted && errors.Identity?.SBTemplateId && (
                <div data-testid="error-SBTemplateId" className={Styles.error}>
                  {errors.Identity?.SBTemplateId}
                </div>
              )}
              <br />
              <label className={Styles.label}>
                <Input
                  name="Identity.Name"
                  label="Template Name*"
                  autocomplete="off"
                  type="text"
                  value={values.Identity.Name}
                  onChange={(e) => handleChange("Identity.Name", e)}
                />
              </label>
              {isSubmitted && errors.Identity?.Name && (
                <div data-testid="error-Name" className={Styles.error}>
                  {errors.Identity?.Name}
                </div>
              )}
              <br />
              <label className={Styles.label}>
                <Input
                  name="Identity.Description"
                  label="Template Description*"
                  autocomplete="off"
                  type="text"
                  value={values.Identity.Description}
                  onChange={(e) => handleChange("Identity.Description", e)}
                />
              </label>
              {isSubmitted && errors.Identity?.Description && (
                <div data-testid="error-Description" className={Styles.error}>
                  {errors.Identity?.Description}
                </div>
              )}
              <br />
              <label className={Styles.label}>ZPL File*</label>
              <input
                className={`${Styles.fileInput} form-control form-control-lg`}
                type="file"
                name="myfile"
                ref={inputFile}
                onChange={onChangetext}
              />
              {isSubmitted && errors.Configuration?.TemplateFormat && (
                <div
                  data-testid="error-TemplateFormat"
                  className={Styles.error}
                >
                  {errors.Configuration?.TemplateFormat}
                </div>
              )}
              <br />
              <label className={Styles.label}>
                <Input
                  name="Configuration.Height"
                  label="Height"
                  autocomplete="off"
                  type="text"
                  value={values.Configuration.Height}
                  onChange={(e) => handleChange("Configuration.Height", e)}
                />
              </label>
              {isSubmitted && errors.Configuration?.Height && (
                <div data-testid="error-Height" className={Styles.error}>
                  {errors.Configuration?.Height}
                </div>
              )}
              <br />
              <label className={Styles.label}>
                <Input
                  name="Configuration.Width"
                  label="Width"
                  autocomplete="off"
                  type="text"
                  value={values.Configuration.Width}
                  onChange={(e) => handleChange("Configuration.Width", e)}
                />
              </label>
              {isSubmitted && errors.Configuration?.Width && (
                <div data-testid="error-Width" className={Styles.error}>
                  {errors.Configuration?.Width}
                </div>
              )}
              <br />
              <label className={`${Styles.label} ${Styles.fileLabel}`}>
                Template Image*
              </label>
              <input
                name="Configuration.Image"
                className={`${Styles.fileInput} form-control form-control-lg`}
                id="formFileLg"
                type="file"
                ref={inputImage}
                onChange={onChangeFile}
              />
              {isSubmitted && errors.Configuration?.Image && (
                <div
                  data-testid="error-Configuration-Image"
                  className={Styles.error}
                >
                  {errors.Configuration?.Image}
                </div>
              )}
              <br />
              <Button
                type="submit"
                className={Styles.button}
                disabled={isSaveButtonDisabled}
              >
                Save
              </Button>
            </form>
            <Modal
              isOpen={isResponseOpen}
              onClose={() => setResponseOpen(false)}
              layout="default"
              header={{
                isDismissible: true
              }}
            >
              <div>
                <h3 className="text-center fw-500">{apiHeading}</h3>
                <h5 className="fw-400">{apiMessage}</h5>
              </div>
            </Modal>
          </Box>
        )}
      </div>

      <Footerfile />
    </div>
  );
};
export default AddTemplate;
